import { useEffect, useRef, useState } from 'react';
import { LANGS, getLang, setLang, onLangChange, langMeta } from './i18n';

// 🌐 Til tanlagich — sidebar pastida (avatar/🌙/chiqish qatorida) va login sahifasida.
// `translate="no"` — til nomlari o'z tilida qoladi (lug'at ularni o'girmasin).
// compact = sidebar yig'ilgan (faqat bayroq).
export default function LangSwitcher({ compact = false, up = true, className = '' }) {
  const [lang, setL] = useState(getLang());
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  useEffect(() => onLangChange(setL), []);
  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  const cur = langMeta(lang);
  const pick = async (code) => {
    setOpen(false);
    if (code === lang) return;
    setBusy(true);
    try { await setLang(code); } finally { setBusy(false); }
  };
  return (
    <div ref={ref} translate="no" className={`relative ${className}`}>
      <button type="button" onClick={() => setOpen(o => !o)} title={`Til / Language — ${cur.name}`}
        className={`inline-flex items-center gap-1.5 p-2 rounded-lg text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 transition ${busy ? 'opacity-60' : ''}`}>
        <span className="text-base leading-none">{cur.flag}</span>
        {!compact && <span className="font-medium">{cur.name}</span>}
      </button>
      {open && (
        <ul className={`absolute ${up ? 'bottom-full mb-1' : 'top-full mt-1'} left-0 z-50 w-44 py-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg`}>
          {LANGS.map(l => (
            <li key={l.code}>
              <button type="button" onClick={() => pick(l.code)}
                className={`w-full flex items-center gap-2 px-3 py-1.5 text-sm text-left hover:bg-gray-100 dark:hover:bg-gray-700 ${l.code === lang ? 'text-primary-700 dark:text-primary-400 font-semibold' : 'text-gray-700 dark:text-gray-300'}`}>
                <span className="text-base leading-none">{l.flag}</span>
                <span className="flex-1">{l.name}</span>
                {l.code === lang && <span>✓</span>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
